import DateFnsUtils from '@date-io/date-fns'
import { Box } from '@material-ui/core'
import { AccessTime } from '@material-ui/icons'
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { format, isAfter } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { useForm } from '../../../providers'

const startTimeDefaultValue = new Date()
startTimeDefaultValue.setHours(9)
startTimeDefaultValue.setMinutes(0)

const endTimeDefaultValue = new Date()
endTimeDefaultValue.setHours(17)
endTimeDefaultValue.setMinutes(0)

export const ShiftTimings = () => {
    const { dispatch } = useForm()
    const [shiftStarTime, setShiftStartTime] = useState(startTimeDefaultValue)
    const [shiftEndTime, setShiftEndTime] = useState(endTimeDefaultValue)

    useEffect(() => {
        if (isAfter(shiftStarTime, shiftEndTime)) {
            setShiftEndTime(shiftStarTime)
        }
        dispatch({
            type: 'SHIFT_TIME',
            payload: { type: 'shiftTime', value: format(shiftStarTime, 'HH:mm') + '-' + format(shiftEndTime, 'HH:mm') },
        })
    }, [shiftStarTime, dispatch, shiftEndTime])

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Box display="flex" flexDirection="row">
                <KeyboardTimePicker
                    style={{ marginRight: '10px' }}
                    label="Shift Start Time"
                    format="hh:mm a"
                    value={shiftStarTime}
                    keyboardIcon={<AccessTime />}
                    onChange={(date) => setShiftStartTime(date)}
                />
                <KeyboardTimePicker
                    onChange={(date) => setShiftEndTime(date)}
                    label="Shift End Time"
                    value={shiftEndTime}
                    keyboardIcon={<AccessTime />}
                    format="hh:mm a"
                />
            </Box>
        </MuiPickersUtilsProvider>
        // <FormControl fullWidth error={error?.shiftTime ? true : false}>
        // 	<FormLabel style={{ marginBottom: '0.5rem' }}>{'Shift Time'}</FormLabel>
        // 	<Select
        // 		labelId="shiftTime"
        // 		variant="outlined"
        // 		id="shiftTime"
        // 		value={formState.shiftTime}
        // 		onChange={(e) =>
        // 			dispatch({
        // 				type: 'SHIFT_TIME',
        // 				payload: { type: 'shiftTime', value: format(shiftStarTime, 'HH:mm') + '-' + format(shiftEndTime, 'HH:mm') },
        // 			})
        // 		}
        // 		fullWidth>
        // 		{shiftTimings.map((shift) => (
        // 			<MenuItem key={shift.id} value={shift.title}>
        // 				{shift.title}
        // 			</MenuItem>
        // 		))}
        // 	</Select>
        // 	<FormHelperText> {error?.shiftTime?.error || ''} </FormHelperText>
        // </FormControl>
    )
}
